import { makeStyles } from '@mui/styles';

export const useStyles = makeStyles(theme => ({
  SliderBottomContainer: {
    display: 'flex',
    width: '100%',
    height: 73,
    marginTop: 25,
    padding: '12px 12px',
    borderRadius: '18px',
    border: '2px solid #43566C',
    backgroundColor: theme.colors.dark.darkSlateBlue,
  },
}));

export const useStylesButton = makeStyles(theme => ({
  root: {
    width: '100%',
    height: 46,
    color: theme.colors.light.freshPowder,
    opacity: 'none',
    boxShadow: 'none',
    borderRadius: 10,
    backgroundColor: theme.colors.orange.orange,
  },
  disabled: {
    color: `${theme.colors.dark.grayBlue} !important`,
  },
}));
